import { Component, ElementRef, NgZone, OnInit, TemplateRef, ViewChild,ChangeDetectorRef} from "@angular/core";
import { FormGroup,  FormBuilder, Validators, FormControl } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../../services/admin.service";
import { apiUrl } from "../../../global/global";
import { ToastrService } from "ngx-toastr";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal"; 

@Component({
  selector: "app-add-edu",
  templateUrl: "./add-edu.component.html",
  styleUrls: ["./add-edu.component.css"]
})
export class AddEduComponent implements OnInit {
  modalRef?: BsModalRef;
  form: FormGroup;
  showError = false;
  showGPAError = false;
  // uni&spec
  allSpec:any=[];
  allUni:any=[];
  allEducationList:any=[];
  // datepicker
  minDate = new Date();
	maxDate = new Date();
	today: Date | undefined;
  title="Add";
  editId ="";
  datePipe: any;
  config = {
    backdrop: true,
    ignoreBackdropClick: false
  };
  
  showOtherDegree : boolean = false;
  showOtherUniversity : boolean = false;
  constructor(private modalService: BsModalService,private formBuilder: FormBuilder,public route: ActivatedRoute, private router: Router,private api: AdminService,private toastrService: ToastrService,private cdf:ChangeDetectorRef) {
    this.form = this.formBuilder.group({
      id: [""],
      specializationId: ["", Validators.compose([Validators.required])],
      otherTitleSpecialization: [""],
      universityId: ["", Validators.compose([Validators.required])],
      otherTitleUniveristy: [""],
      fromDate: [""],
      toDate: [""],
      description: ["", Validators.compose([Validators.minLength(3),Validators.maxLength(250)])],
      gpa: [""],
      isPursuing: [""],
    });
   }

  ngOnInit(): void {
    this.getEdu();
    this.getUniSpec();
  }
  // date picker only accpedct number
  onKeyDown(event: KeyboardEvent) {
    const key = event.key;
    if (!/^\d+$/.test(key)) {
      event.preventDefault();
    }
  }
  
  // check if only number
  preventNumbers(event): boolean { 
    event = (event) ? event : window.event;
    var charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
    }
    return true;
  }
  // getEdu
  getEdu(){
    this.api.stopLoader(); 
    this.api.getDatas(apiUrl._getEdu)
    .subscribe(async (res) => {
      this.allEducationList = res.data;
      if(this.allEducationList != ""){
        this.router.navigate(["/education/add"]);
      } else{
        this.router.navigate(["/education"]);
      }
    })
  } 
  // edit
  edit(edu,template: TemplateRef<any>){
    this.editId =edu.id;
    this.title ="Edit"
    if (edu.isPursuing == 0) {
      this.form.controls['toDate'].enable();
    } else if (edu.isPursuing == 1){
      this.form.controls['toDate'].disable();
    }
    
    setTimeout(() => {
      this.form.patchValue({
        ...edu,
        fromDate:edu.fromDate ? new Date(edu.fromDate):"",
        toDate: edu.toDate ? new Date(edu.toDate) : "",
      })
      if (edu.isPursuing == 1) {
        this.form.controls['toDate'].disable();
      }
    }, 500);
    this.modalRef = this.modalService.show(
      template,
      Object.assign({},this.config, { class: "modal-lg addModal maxWidth  centerAlign" })
    );
    
  }
// delete
delete(id){
  const data={"id":id}
  this.api.deleteData(apiUrl._delEdu,data)
    .subscribe(async (res) => { 
      this.toastrService.success("", "Education Deleted Successfully!");
      this.getEdu();
  })
}

  // getUniSpec
  getUniSpec(){
    this.api.getDatas(apiUrl._allUniSpec)
    .subscribe(async (res) => {
      this.allSpec = res.data.specialization;
      this.allUni = res.data.universities;
    })
  } 
 
  selectedDegree(event){
    this.allSpec.map((deg)=>{
      if(event == deg.id && deg.name == "Other"){
        this.showOtherDegree = true;
      } else{
        this.showOtherDegree= false
      }
    })
  }
  selectedUniversity(event){
    this.allUni.map((uni)=>{
      if(event == uni.id && uni.name == "Other"){
        this.showOtherUniversity = true;
      } else{this.showOtherUniversity= false}
    })
  }
  openModal(template: TemplateRef<any>) { 
    this.form.reset()
    this.form.controls['toDate'].enable();
    this.title ="Add"
    this.modalRef = this.modalService.show(
      template,
      Object.assign({},this.config, { class: "modal-lg addModal maxWidth  centerAlign" })
    );
    setTimeout(() => {
      this.form.reset()
    }, 200);
  }

  closeModal(){
    this.editId=""
   setTimeout(() => {
    this.form.reset()
  }, 200);
   this.modalService.hide();
  }
  // on submit
  onSubmit(){
    if(this.form.value.isPursuing == 1 || this.form.value.isPursuing == true){
      this.form.patchValue({
        isPursuing : 1
      })
    }
    
    if(this.form.value.gpa > 4 && this.form.value.gpa >= 0){
      this.showGPAError= true;
      setTimeout(() => {
        this.showGPAError= false;
      }, 3000);
      return
    } else{
      this.showGPAError = false
    }
    
    if(this.showOtherDegree == true && this.form.value.otherTitleSpecialization == ""){
      this.showError= true;
      return
    } else{
      this.showError=false
    }
  if(this.showOtherUniversity == true && this.form.value.otherTitleUniveristy == ""){
      this.showError= true;
      return
    } else{
      this.showError=false
    }
    if(this.form.valid){
      if(this.editId){
        this.api.putData(apiUrl._updateEduV1, this.removeEmptyFiled(this.form))
        .subscribe(async (res) => {
          this.toastrService.success("", "Education Updated Successfully!");
          this.getEdu();
          this.modalRef?.hide();
        })
      } else{
        delete this.form.value.id;
        this.api.postData(apiUrl._addEduV1, this.removeEmptyFiled(this.form))
        .subscribe(async (res) => {
          this.toastrService.success("", "Education Added Successfully!");
          this.getEdu();
          this.modalRef?.hide();
        })
      }
    } else{
      this.showError= true;
      setTimeout(() => {
        this.showError= false;
      }, 3000);
    }
    
  }
   
  removeEmptyFiled(form){
    const formValues = form.value;
    const formKeys = Object.keys(formValues);
    if (formKeys.length) {
      for (let i = 0; i < formKeys.length; i++) {
        if (
          formValues[formKeys[i]] == null ||
          formValues[formKeys[i]] == undefined ||
          formValues[formKeys[i]] == ""
        ) {
          delete formValues[formKeys[i]];
        }
      }
    }

    return formValues
  }
  isDisabled(event:any){
    if(event.target.checked) {
      this.form.controls['toDate'].disable();
    } else {
      this.form.controls['toDate'].enable();
    }
  }
}